import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('LIST_PRESENTATION', {
  TOGGLE_LIST_VIEW: null
});
